import src from "IMAGE";
export default { src, width: 648, height: 668, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
